module.exports = __webpack_public_path__ + "img/0220-2101-HR-Visual-RGB-dunkel.874a473f.svg";